baseHasIn